import type { ReactNode } from 'react';

import { cn } from '@/utils/classname';

interface RadioCardProps {
  selected: boolean;
  onSelect: () => void;
  title: string;
  description: string;
  testId: string;
  children?: ReactNode;
}

// Card-style radio option used by the SessionStep to pick where the session
// lives in the login response. Clicking anywhere on the card selects it;
// the children render the strategy-specific input fields when selected.
export function RadioCard({
  selected,
  onSelect,
  title,
  description,
  testId,
  children,
}: RadioCardProps) {
  return (
    <div
      className={cn(
        'cursor-pointer rounded-md border p-4 transition-colors',
        selected
          ? 'border-chariot-brand-primary bg-chariot-background-secondary/50'
          : 'border-chariot-stroke hover:bg-chariot-background-secondary/30'
      )}
      onClick={onSelect}
      data-testid={testId}
    >
      <div className="flex items-start gap-3">
        <div
          className={cn(
            'mt-1 size-4 shrink-0 rounded-full border-2',
            selected
              ? 'border-chariot-brand-primary bg-chariot-brand-primary'
              : 'border-chariot-stroke'
          )}
        />
        <div className="flex-1">
          <div className="text-chariot-text-primary font-medium">{title}</div>
          <p className="text-chariot-text-secondary mt-1 text-sm">
            {description}
          </p>
          {selected && children && (
            <div className="mt-3" onClick={e => e.stopPropagation()}>
              {children}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
